import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  roles: [],
}

export const mutations = {
  SET_ROLES(state, roles) {
    state.roles = roles
  },
}

export const actions = {
  fetchRoles({ commit }, payload) {
    return ApiService.fetchRoles(payload)
      .then((res) => {
        const roles = res.data.data
        commit('SET_ROLES', roles)
      })
      .catch((error) => {
        throw error
      })
  },
}
